export default "__VITE_ASSET__DKUqdGZU__"